// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/dashboard/dashboard.css
// module id = 497
// module chunks = 0